<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Produkty</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Produkty</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span :class="chevronFiltersClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content cats" v-show="isFiltersOpen">
            <div class="row">
              <div v-if="categories" class="col-sm-5">
                <div class="form-group">
                  <label class="control-label col-sm-2">Kategoria</label>
                  <Multiselect
                    v-model="filterCategory"
                    :options="categories"
                    label="name"
                    :searchable="true"
                    :close-on-select="true"
                  >
                    <template #option="{ option }">
                      <template v-if="isFirstInGroup(option)">
                        <div class="group-label">
                          {{ option.group }}
                        </div>
                      </template>
                      <div
                        :class="{ first: isFirstInGroup(option) }"
                        class="option-item"
                      >
                        {{ option.name }}
                      </div>
                    </template>
                  </Multiselect>
                </div>
              </div>
              <div
                v-if="canDisplaySites && filterSites.length"
                class="col-sm-3"
              >
                <div class="form-group">
                  <label class="control-label">Domena</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="sitePk"
                      mode="single"
                      placeholder="Domena"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="filterSites"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Produkty</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddProduct" to="/products/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <template v-if="canAddProduct">
              <button
                @click="publishMany(true)"
                :disabled="isPublishing !== null"
                class="btn btn-sm btn-primary"
              >
                <font-awesome-icon
                  v-if="isPublishing === true"
                  icon="spinner"
                  spin
                />
                <span v-else>Publikuj</span>
              </button>
              <button
                @click="publishMany(false)"
                :disabled="isPublishing !== null"
                class="btn btn-sm btn-primary"
              >
                <font-awesome-icon
                  v-if="isPublishing === false"
                  icon="spinner"
                  spin
                />
                <span v-else>Wyłącz</span>
              </button>
              <button
                @click="popularMany(true)"
                :disabled="isPopularPending !== null"
                class="btn btn-sm btn-primary"
              >
                <font-awesome-icon
                  v-if="isPopularPending === true"
                  icon="spinner"
                  spin
                />
                <span v-else>Dodaj do najpopularniejszych</span>
              </button>
              <button
                @click="popularMany(false)"
                :disabled="isPopularPending !== null"
                class="btn btn-sm btn-primary"
              >
                <font-awesome-icon
                  v-if="isPopularPending === false"
                  icon="spinner"
                  spin
                />
                <span v-else>Usuń z listy najpopularniejszych</span>
              </button>
              <button @click="importFn()" class="btn btn-sm btn-primary">
                Importuj logi
              </button>
            </template>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="items && itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <div class="table-responsive table-search native-table-search">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th class="select-column">
                          <input
                            type="checkbox"
                            :checked="areAllVisibleSelected"
                            @change="toggleSelectAllVisible"
                          />
                        </th>
                        <th class="drag-column"></th>
                        <th class="index-column">#</th>
                        <th
                          v-for="header in tableHeaders"
                          :key="header.value"
                          :class="[
                            'native-header-cell',
                            { sortable: header.sortable },
                          ]"
                        >
                          <div class="native-header-content">
                            <button
                              v-if="header.sortable"
                              type="button"
                              class="native-sort-button"
                              @click="toggleSort(header.value)"
                            >
                              <span>{{ header.text }}</span>
                              <i
                                v-show="isSortedHeader(header.value)"
                                :class="sortIconClass(header.value)"
                                class="sort-icon fa"
                              ></i>
                            </button>
                            <span v-else>{{ header.text }}</span>
                            <input
                              v-if="header.search"
                              :value="searchValue[header.value] || ''"
                              class="table-search native-header-input"
                              type="text"
                              @input="
                                updateSearchValue(
                                  header.value,
                                  $event.target.value
                                )
                              "
                              @keyup="search"
                              @click.stop="isSearch = true"
                            />
                            <button
                              v-if="header.radio"
                              type="button"
                              @click="setRadioFilter(header.value)"
                              class="activeFilter native-radio-filter"
                              :class="{
                                active: radioValue[header.value] === true,
                                inactive: radioValue[header.value] === false,
                              }"
                            >
                              <div v-if="radioValue[header.value] === false">
                                <i class="fa fa-times"></i>
                              </div>
                              <div
                                v-else-if="radioValue[header.value] === true"
                              >
                                <i class="fa fa-check"></i>
                              </div>
                            </button>
                          </div>
                        </th>
                        <th class="actions-column">Akcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td
                          :colspan="tableHeaders.length + 4"
                          class="text-center"
                        >
                          Ładowanie...
                        </td>
                      </tr>
                      <tr v-else-if="!items.length">
                        <td
                          :colspan="tableHeaders.length + 4"
                          class="text-center"
                        >
                          Brak wyników
                        </td>
                      </tr>
                      <tr
                        v-else
                        v-for="(item, index) in items"
                        :key="item.pk"
                        class="reorder-row"
                        :class="{
                          'drag-over-row': dragOverProductPk === item.pk,
                        }"
                        :draggable="canReorder"
                        @dragstart="onProductDragStart(index, $event)"
                        @dragenter.prevent="onProductDragOver(index, $event)"
                        @dragover="onProductDragOver(index, $event)"
                        @drop.prevent="onProductDrop(index, $event)"
                        @dragend="onProductDragEnd"
                      >
                        <td class="select-column" @click.stop>
                          <input
                            type="checkbox"
                            :checked="isItemSelected(item.pk)"
                            @change="toggleItemSelection(item)"
                          />
                        </td>
                        <td class="drag-column" @click.stop>
                          <span
                            v-if="canReorder"
                            class="drag-handle"
                            title="Przeciągnij, aby zmienić kolejność"
                          >
                            <i class="fa fa-bars"></i>
                          </span>
                        </td>
                        <td class="index-column">{{ rowNumber(index) }}</td>
                        <td>{{ item.pk }}</td>
                        <td>{{ item.name || "-" }}</td>
                        <td class="text-center">
                          <font-awesome-icon
                            v-if="item.is_published"
                            icon="check"
                            class="table-helper-item"
                          />
                          <font-awesome-icon
                            v-else
                            icon="times"
                            class="table-helper-item"
                          />
                        </td>
                        <td class="text-center">
                          <font-awesome-icon
                            v-if="item.is_available_on_allegro"
                            icon="check"
                            class="table-helper-item"
                          />
                          <font-awesome-icon
                            v-else
                            icon="times"
                            class="table-helper-item"
                          />
                        </td>
                        <td>{{ item.date_from || "-" }}</td>
                        <td>{{ item.date_to || "-" }}</td>
                        <td>{{ item.date_added || "-" }}</td>
                        <td>{{ item.date_modified || "-" }}</td>
                        <td>{{ item.last_modified_by || "-" }}</td>
                        <td class="actions-column" @click.stop>
                          <router-link
                            v-if="item && canChangeProduct"
                            :to="'/products/edit/' + item.pk"
                          >
                            <button class="btn btn-warning btn-xs">
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                            </button>
                          </router-link>
                          <button
                            v-if="canDeleteProduct"
                            @click.stop="
                              showModal = item.pk;
                              deleteName = item.name;
                            "
                            class="btn btn-danger btn-xs"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                          <button
                            v-if="canAddProduct"
                            @click.stop="copyProduct(item.pk)"
                            class="btn btn-primary btn-xs"
                          >
                            <i class="fa fa-copy"></i>
                          </button>
                          <button class="btn btn-primary add-info">
                            <span class="fa fa-info"></span>
                            <div class="add-info-box">
                              Data dodania: {{ item.date_added }} <br />
                              Data modyfikacji: {{ item.date_modified }} <br />
                              Edytowano przez: {{ item.last_modified_by }}
                              <br />
                            </div>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="pagination" v-if="items && itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteProducts(showModal)"
    @callbackClose="showModal = false"
  />
  <div v-if="mImport" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Import operacji grup/opcji produktu</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12">
                  <Multiselect
                    v-model="pOption"
                    mode="single"
                    placeholder="Produkt"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="importProductSelect.options"
                    :filter-results="false"
                    :loading="importProductSelect.loading"
                    @search-change="importProductSelect.onSearch"
                    @open="importProductSelect.bindScroll"
                    @close="importProductSelect.unbindScroll"
                    :hideSelected="true"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mImport = false" class="btn btn-white">Anuluj</button>
          <button
            @click="applyLogs()"
            :disabled="!pOption || isApplyingLogs"
            class="btn btn-primary"
          >
            {{ isApplyingLogs ? "Importowanie..." : "Importuj" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mImport" @click="mImport = false" class="modal-backdrop"></div>
</template>

<script>
import { computed, watch, ref, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import { usePagedSelect } from "../../composables/usePagedSelect";
import { getPermittedSiteIds, hasPermission } from "../../permissions";
import { productPermissionsConst } from "../../constants/productConstants";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";

export default {
  name: "ProductsList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    // Copying, publishing, the popular flag and applying logs are all POST
    // endpoints, for which the backend checks the add permission.
    const canAddProduct = computed(() =>
      hasPermission(productPermissionsConst.add)
    );
    // Reordering is a PATCH on the product.
    const canChangeProduct = computed(() =>
      hasPermission(productPermissionsConst.update)
    );
    const canDeleteProduct = computed(() =>
      hasPermission(productPermissionsConst.delete)
    );
    // The domain filter only makes sense when the user may view products on
    // more than one site.
    const permittedSiteIds = getPermittedSiteIds(productPermissionsConst.view);
    const canDisplaySites = computed(() => permittedSiteIds.length > 1);
    const deleteProductsData = computed(
      () => store.getters.getDeleteProductsData
    );
    const machineData = computed(() => store.getters.getMachineData);
    const updateProductsData = computed(
      () => store.getters.getUpdateProductsData
    );
    const productsData = computed(() => store.getters.getProductsData);
    const categoriesData = computed(
      () => store.getters.getCategoriesAdminProductData
    );
    const publishProductsData = computed(
      () => store.getters.getPublishProductsData
    );
    const popularProductsData = computed(
      () => store.getters.getPopularProductsData
    );
    const copyProductData = computed(() => store.getters.getCopyProductData);
    const sitesData = computed(() => store.getters.getSitesData);
    const productObj = ref({
      name: "",
      model: "",
      type: "",
      image: "",
    });
    let headers = [
      { text: "ID", value: "id", search: true },
      {
        text: "Nazwa",
        value: "name",
        sortable: true,
        search: true,
      },
      {
        text: "Opublikowany",
        value: "is_published",
        sortable: false,
        search: false,
        radio: true,
      },
      {
        text: "Allegro",
        value: "is_available_on_allegro",
        sortable: false,
        search: false,
        radio: true,
      },
      {
        text: "Data od",
        value: "date_from",
        sortable: true,
        search: true,
      },
      { text: "Data do", value: "date_to", sortable: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      { text: "Edytowano przez", value: "last_modified_by" },
      { text: "Akcje", value: "actions" },
    ];

    const items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const mImport = ref(false);
    const rowsPerPage = ref();
    const itemsSelected = ref([]);
    const pOption = ref();
    const isApplyingLogs = ref(false);
    // true/false while a bulk publish/unpublish request is pending, null when idle.
    const isPublishing = ref(null);
    // Same for the bulk "most popular" add/remove.
    const isPopularPending = ref(null);
    const sitePk = ref(null);
    const categories = ref([]);
    const filterCategory = ref();
    const radioValue = ref({});
    const filterSites = ref([]);
    const siteFilterInitialized = ref(false);
    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);
    const draggedProductPk = ref(null);
    const dragOverProductPk = ref(null);
    const canReorder = computed(() => canChangeProduct.value);
    const tableHeaders = computed(() =>
      headers.filter((header) => header.value !== "actions")
    );

    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
      sortBy: "position",
      sortType: "asc",
    });

    const options = [
      { type: "group", label: "Frontend" },
      { value: 1, name: "Vue.js", group: "Frontend" },
      { value: 2, name: "React", group: "Frontend" },
      { type: "group", label: "Backend" },
      { value: 3, name: "Node.js", group: "Backend" },
      { value: 4, name: "Django", group: "Backend" },
    ];

    const getProducts = async () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getProducts", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        category: filterCategory.value,
        radio: radioValue.value,
        site_pk: sitePk.value,
      });
    };

    const deleteProducts = (pk) => {
      showModal.value = false;
      if (!canDeleteProduct.value) {
        return;
      }
      store.dispatch("deleteProducts", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      store.dispatch("updateProducts", productObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editProduct = (item) => {
      cancel();
      store.dispatch("getProduct", { pk: item.pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getProducts();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getProducts();
    };

    const updateSearchValue = (key, value) => {
      searchValue.value = {
        ...searchValue.value,
        [key]: value,
      };
    };

    const toggleSort = (value) => {
      if (serverOptions.value.sortBy === value) {
        serverOptions.value.sortType =
          serverOptions.value.sortType === "asc" ? "desc" : "asc";
        return;
      }
      serverOptions.value.sortBy = value;
      serverOptions.value.sortType = "asc";
    };

    const isSortedHeader = (value) => serverOptions.value.sortBy === value;

    const sortIconClass = (value) =>
      isSortedHeader(value) && serverOptions.value.sortType === "desc"
        ? "fa-arrow-down"
        : "fa-arrow-up";

    const isItemSelected = (pk) => {
      return itemsSelected.value.some((element) => element.pk === pk);
    };

    const toggleItemSelection = (item) => {
      if (isItemSelected(item.pk)) {
        itemsSelected.value = itemsSelected.value.filter(
          (selectedItem) => selectedItem.pk !== item.pk
        );
        return;
      }

      itemsSelected.value = [...itemsSelected.value, item];
    };

    const areAllVisibleSelected = computed(() => {
      if (!items.value.length) {
        return false;
      }
      return items.value.every((item) => isItemSelected(item.pk));
    });

    const toggleSelectAllVisible = () => {
      if (areAllVisibleSelected.value) {
        const visiblePks = new Set(items.value.map((item) => item.pk));
        itemsSelected.value = itemsSelected.value.filter(
          (item) => !visiblePks.has(item.pk)
        );
        return;
      }

      const selectedByPk = new Map(
        itemsSelected.value.map((item) => [item.pk, item])
      );
      items.value.forEach((item) => {
        selectedByPk.set(item.pk, item);
      });
      itemsSelected.value = Array.from(selectedByPk.values());
    };

    const importFn = () => {
      if (!canAddProduct.value) {
        return;
      }
      if (itemsSelected.value.length > 0) {
        mImport.value = true;
      } else {
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie wybrano żadnych produktów",
        });
      }
    };

    // Mirrors ProductLogApplyManyModalController from the old admin panel.
    const applyLogs = () => {
      if (!canAddProduct.value || !pOption.value || isApplyingLogs.value) {
        return;
      }
      isApplyingLogs.value = true;
      store
        .dispatch("applyManyProductLog", {
          productToApply: pOption.value,
          products: itemsSelected.value.map((element) => element.pk),
        })
        .then((response) => {
          const skipped = Array.isArray(response?.data) ? response.data : [];
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane produktu zostały zaktualizowane!",
          });
          if (skipped.length) {
            store.dispatch("showToaster", {
              type: "error",
              content: `Pominięte operacje: ${skipped.length}`,
            });
          }
          mImport.value = false;
          pOption.value = null;
          getProducts();
        })
        .catch(() => {
          store.dispatch("showToaster", {
            type: "error",
            content: "Wystąpił błąd!",
          });
        })
        .finally(() => {
          isApplyingLogs.value = false;
        });
    };

    const publishMany = (type) => {
      if (!canAddProduct.value || isPublishing.value) {
        return;
      }
      let publishData = [];
      itemsSelected.value.forEach((element) => {
        publishData.push({
          pk: element.pk,
          is_published: type,
        });
      });
      if (publishData.length > 0) {
        isPublishing.value = type;
        store.dispatch("publishProducts", publishData).finally(() => {
          isPublishing.value = null;
        });
      } else {
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie wybrano żadnych produktów",
        });
      }
    };

    const popularMany = (type) => {
      if (!canAddProduct.value || isPopularPending.value !== null) {
        return;
      }
      let popularData = [];
      itemsSelected.value.forEach((element) => {
        popularData.push({
          pk: element.pk,
          is_popular: type,
        });
      });
      if (popularData.length > 0) {
        isPopularPending.value = type;
        store.dispatch("popularProducts", popularData).finally(() => {
          isPopularPending.value = null;
        });
      } else {
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie wybrano żadnych produktów",
        });
      }
    };

    const copyProduct = (pk) => {
      if (!canAddProduct.value) {
        return;
      }
      store.dispatch("copyProduct", { pk: pk });
    };

    const setRadioFilter = (val) => {
      serverOptions.value.page = 1;
      if (radioValue.value[val] === true) {
        radioValue.value[val] = false;
      } else if (radioValue.value[val] === false) {
        radioValue.value[val] = "x";
      } else {
        radioValue.value[val] = true;
      }
    };

    const getMaxPages = () => {
      const total = Number(itemsAll.value) || 0;
      const perPage = Number(serverOptions.value.rowsPerPage) || 1;
      return Math.max(1, Math.ceil(total / perPage));
    };

    const clampPage = (page) => {
      const max = getMaxPages();
      if (!page || Number.isNaN(Number(page))) return 1;
      return Math.min(Math.max(1, Number(page)), max);
    };

    // Products to import the group/option log from are searched on the server
    // and paged while scrolling, like the product picker of the old apply log
    // modal.
    const importProductSelect = reactive(
      usePagedSelect({
        fetchPage: ({ page, query }) =>
          store.dispatch("searchProductsOptionsList", { page, query }),
        toOption: (element) => ({
          name: "[" + element.pk + "] " + element.name,
          value: element.pk,
        }),
        getSelected: () => pOption.value,
      })
    );
    importProductSelect.reload();

    const selectPage = (page) => {
      serverOptions.value.page = clampPage(page);
    };

    const rowNumber = (index) => {
      const page = Number(serverOptions.value.page) || 1;
      const rows = Number(serverOptions.value.rowsPerPage) || 25;
      return (page - 1) * rows + index + 1;
    };

    const onProductDragStart = (index, event) => {
      if (!canReorder.value) {
        event.preventDefault();
        return;
      }

      const item = items.value[index];
      if (!item) {
        event.preventDefault();
        return;
      }

      draggedProductPk.value = item.pk;
      if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.dropEffect = "move";
        event.dataTransfer.setData("text/plain", String(item.pk));
      }
    };

    const onProductDragOver = (index, event) => {
      if (!canReorder.value) {
        return;
      }

      const item = items.value[index];
      if (!item) {
        return;
      }

      event.preventDefault();
      if (event?.dataTransfer) {
        event.dataTransfer.dropEffect = "move";
      }
      dragOverProductPk.value = item.pk;
    };

    const onProductDragEnd = () => {
      draggedProductPk.value = null;
      dragOverProductPk.value = null;
    };

    const onProductDrop = async (index, event) => {
      if (!canReorder.value) {
        return;
      }
      event.preventDefault();
      const targetItem = items.value[index];

      if (
        !draggedProductPk.value ||
        !targetItem ||
        draggedProductPk.value === targetItem.pk
      ) {
        onProductDragEnd();
        return;
      }

      const fromIndex = items.value.findIndex(
        (i) => i.pk === draggedProductPk.value
      );
      const toIndex = index;
      if (fromIndex < 0 || toIndex < 0) {
        onProductDragEnd();
        return;
      }

      const [movedItem] = items.value.splice(fromIndex, 1);
      items.value.splice(toIndex, 0, movedItem);

      const page = Number(serverOptions.value.page) || 1;
      const rows = Number(serverOptions.value.rowsPerPage) || 25;
      const zeroBasedPosition = (page - 1) * rows + toIndex;

      onProductDragEnd();
      try {
        await store.dispatch("reorderProducts", {
          pk: movedItem.pk,
          position: zeroBasedPosition,
        });
        await getProducts();
        store.dispatch("showToaster", {
          type: "success",
          content: "Kolejność produktów została zaktualizowana",
        });
      } catch (e) {
        await getProducts();
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie udało się zmienić kolejności produktów",
        });
      }
    };

    store.dispatch("getCategoriesAdminProductFilter");
    store.dispatch("getSites");

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    const isFirstInGroup = (option) => {
      const index = categories.value.findIndex(
        (item) => item.group === option.group
      );
      return categories.value[index]?.id === option.id;
    };

    onMounted(() => {
      if (localStorage.getItem("prodsSearchValue") !== null) {
        searchValue.value = localStorage.getItem("prodsSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (localStorage.getItem("prodsRadioValue") !== null) {
        radioValue.value = localStorage.getItem("prodsRadioValue");
        radioValue.value = JSON.parse(radioValue.value);
      }
      // if (localStorage.getItem("prodsFilterCategory") !== null) {
      //   filterCategory.value = localStorage.getItem("prodsFilterCategory");
      //   filterCategory.value = JSON.parse(filterCategory.value);
      // }
    });

    watch(
      () => [searchValue.value, radioValue.value, filterCategory.value],
      function () {
        localStorage.setItem(
          "prodsSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "prodsRadioValue",
          JSON.stringify(radioValue.value)
        );
        localStorage.setItem(
          "prodsFilterCategory",
          JSON.stringify(filterCategory.value)
        );
        getProducts();
      },
      { deep: true }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        if (newValue.data) {
          const rawSites = Array.isArray(newValue.data?.results)
            ? newValue.data.results
            : [];
          filterSites.value = rawSites
            .filter((element) => permittedSiteIds.includes(element.pk))
            .map((element) => ({
              name: element.name,
              value: element.pk,
            }));

          if (!hasSiteOptionValue(filterSites.value, sitePk.value)) {
            const defaultSiteValue = getSiteValueFromCurrentUrl(
              filterSites.value
            );
            if (defaultSiteValue !== null) {
              sitePk.value = defaultSiteValue;
            }
          }

          if (!siteFilterInitialized.value) {
            siteFilterInitialized.value = true;
            getProducts();
          }
        }
      }
    );

    watch(
      () => productsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [...(newValue.data.results || [])];
        // Like the old admin, selection lives only as long as the loaded page -
        // otherwise rows picked on other pages/filters leak into bulk actions.
        itemsSelected.value = [];
        loading.value = false;
      }
    );

    watch(
      () => machineData.value,
      function (newValue) {
        productObj.value = newValue.data;
      }
    );

    watch(
      () => deleteProductsData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Maszyna została usunieta",
          });
        }
        getProducts();
      }
    );

    watch(
      () => publishProductsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          let strPublish = "opublikowane";
          if (newValue.data[0].is_published === false) {
            strPublish = "wyłączone";
          }
          store.dispatch("showToaster", {
            type: "success",
            content: "Wybrane produkty zostały " + strPublish,
          });
        } else {
          store.dispatch("showToaster", {
            type: "error",
            content: "Wystąpił błąd!",
          });
        }
        getProducts();
      }
    );

    watch(
      () => popularProductsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          let strPopular = "dodane do najpopularniejszych";
          if (newValue.data[0].is_popular === false) {
            strPopular = "usunięte z listy najpopularniejszych";
          }
          store.dispatch("showToaster", {
            type: "success",
            content: "Wybrane produkty zostały " + strPopular,
          });
        } else {
          store.dispatch("showToaster", {
            type: "error",
            content: "Wystąpił błąd!",
          });
        }
        getProducts();
      }
    );

    watch(
      () => copyProductData.value,
      function (newValue) {
        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Produkt został skopiowany.",
          });
        }
      }
    );

    watch(
      () => updateProductsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getProducts();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => categoriesData.value,
      (newValue) => {
        if (newValue?.status === 200 && Array.isArray(newValue.data)) {
          const groupedRaw = {};

          newValue.data.forEach((item) => {
            const group = item.parent_title || "Inne";
            if (!groupedRaw[group]) {
              groupedRaw[group] = [];
            }

            groupedRaw[group].push({
              id: item.pk,
              value: item.pk,
              name: `[${item.pk}] ${item.title}`,
              group: group,
            });
          });

          categories.value = Object.entries(groupedRaw).flatMap(
            ([groupName, items]) =>
              items.map((item) => ({ ...item, group: groupName }))
          );
        }
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getProducts();
        }
      },
      { deep: true }
    );

    watch(
      () => serverOptions.value.page,
      function () {
        getProducts();
      }
    );

    watch(
      () => sitePk.value,
      function () {
        getProducts();
      }
    );

    return {
      canAddProduct,
      canChangeProduct,
      canDeleteProduct,
      canDisplaySites,
      headers,
      tableHeaders,
      canReorder,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deleteProducts,
      deleteName,
      productObj,
      cancel,
      editProduct,
      saveEdit,
      searchValue,
      isSearch,
      rowsPerPage,
      resetFilters,
      updateSearchValue,
      toggleSort,
      isSortedHeader,
      sortIconClass,
      search,
      itemsSelected,
      isItemSelected,
      toggleItemSelection,
      areAllVisibleSelected,
      toggleSelectAllVisible,
      filterCategory,
      categories,
      publishMany,
      isPublishing,
      popularMany,
      isPopularPending,
      importFn,
      mImport,
      applyLogs,
      isApplyingLogs,
      importProductSelect,
      pOption,
      copyProduct,
      setRadioFilter,
      radioValue,
      selectPage,
      clampPage,
      getMaxPages,
      setRowsPerPage,
      sitePk,
      filterSites,
      options,
      isFirstInGroup,
      isFiltersOpen,
      isMainOpen,
      chevronFiltersClass,
      chevronMainClass,
      rowNumber,
      dragOverProductPk,
      onProductDragStart,
      onProductDragOver,
      onProductDragEnd,
      onProductDrop,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.reorder-row {
  cursor: move;
}

.drag-handle {
  color: #999;
}

.drag-over-row td {
  border-top: 2px solid #1ab394 !important;
}

.native-header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}

.native-sort-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.native-radio-filter {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
}

.native-header-input {
  display: block;
  width: 100%;
  max-width: 170px;
  margin: 0 auto 8px;
  background-color: #f5f7fa;
  border: 1px solid #d8dde6;
  border-radius: 3px;
}

.native-header-input:focus {
  background-color: #fff;
  border-color: #1ab394;
}
</style>
